/**
 * Redux slice for managing registration state.
 * This slice handles the registration process, including the submission state,
 * registration result, and any registration errors.
 */

import { createSlice } from '@reduxjs/toolkit';
import { PASSWORD_RESET_ERROR, SUCCESS, TOKEN_STATE } from './constants';
import { COMPLETE_STATE, DEFAULT_STATE, FAILURE_STATE, PENDING_STATE } from '../../../../data/constants';
export const storeName = 'resetPassword';
export const REGISTER_SLICE_NAME = 'resetPassword';
export const resetPasswordInitialState = {
  tokenValidationState: DEFAULT_STATE,
  resetPasswordSubmitState: DEFAULT_STATE,
  status: TOKEN_STATE.PENDING,
  token: null,
  errorMsg: null,
  tokenError: null,
  backendValidationError: null
};
export const resetPasswordSlice = createSlice({
  name: REGISTER_SLICE_NAME,
  initialState: resetPasswordInitialState,
  reducers: {
    validateToken: state => {
      state.tokenValidationState = PENDING_STATE;
      state.status = PENDING_STATE;
    },
    validateTokenSuccess: (state, _ref) => {
      let {
        payload
      } = _ref;
      state.tokenValidationState = COMPLETE_STATE;
      state.status = TOKEN_STATE.VALID;
      state.token = payload;
    },
    validateTokenFailed: (state, _ref2) => {
      let {
        payload
      } = _ref2;
      state.status = PASSWORD_RESET_ERROR;
      state.tokenValidationState = DEFAULT_STATE;
      state.tokenError = payload;
    },
    resetPassword: state => {
      state.status = PENDING_STATE;
      state.resetPasswordSubmitState = PENDING_STATE;
    },
    resetPasswordSuccess: state => {
      state.status = SUCCESS;
      state.resetPasswordSubmitState = COMPLETE_STATE;
    },
    resetPasswordFailure: (state, _ref3) => {
      let {
        payload
      } = _ref3;
      state.status = payload.status;
      state.resetPasswordSubmitState = FAILURE_STATE;
      state.errorMsg = payload.errorMsg;
    },
    validatePassword: state => {
      state.backendValidationError = null;
    },
    validatePasswordSuccess: (state, _ref4) => {
      let {
        payload
      } = _ref4;
      state.backendValidationError = payload;
    },
    validatePasswordFailure: state => {
      state.backendValidationError = null;
    }
  }
});
export const {
  validateToken,
  validatePassword,
  validateTokenSuccess,
  validateTokenFailed,
  resetPassword,
  resetPasswordSuccess,
  resetPasswordFailure,
  validatePasswordSuccess,
  validatePasswordFailure
} = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
//# sourceMappingURL=reducers.js.map